// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/blog_post/v1/blog_post.proto (package fingertip.creator.blog_post.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateBlogPostRequest, CreateBlogPostResponse, DeleteBlogPostRequest, DeleteBlogPostResponse, DuplicateBlogPostRequest, DuplicateBlogPostResponse, GetBlogPostPublicRequest, GetBlogPostPublicResponse, GetBlogPostRequest, GetBlogPostResponse, GetBlogPostSlugRequest, GetBlogPostSlugResponse, GetBlogPostsPublicRequest, GetBlogPostsPublicResponse, GetBlogPostsRequest, GetBlogPostsResponse, UpdateBlogPostRequest, UpdateBlogPostResponse } from "./blog_post_pb.js";

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.GetBlogPostPublic
 */
export const getBlogPostPublic = {
  localName: "getBlogPostPublic",
  name: "GetBlogPostPublic",
  kind: MethodKind.Unary,
  I: GetBlogPostPublicRequest,
  O: GetBlogPostPublicResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.GetBlogPostsPublic
 */
export const getBlogPostsPublic = {
  localName: "getBlogPostsPublic",
  name: "GetBlogPostsPublic",
  kind: MethodKind.Unary,
  I: GetBlogPostsPublicRequest,
  O: GetBlogPostsPublicResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.GetBlogPost
 */
export const getBlogPost = {
  localName: "getBlogPost",
  name: "GetBlogPost",
  kind: MethodKind.Unary,
  I: GetBlogPostRequest,
  O: GetBlogPostResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.GetBlogPosts
 */
export const getBlogPosts = {
  localName: "getBlogPosts",
  name: "GetBlogPosts",
  kind: MethodKind.Unary,
  I: GetBlogPostsRequest,
  O: GetBlogPostsResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.CreateBlogPost
 */
export const createBlogPost = {
  localName: "createBlogPost",
  name: "CreateBlogPost",
  kind: MethodKind.Unary,
  I: CreateBlogPostRequest,
  O: CreateBlogPostResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.UpdateBlogPost
 */
export const updateBlogPost = {
  localName: "updateBlogPost",
  name: "UpdateBlogPost",
  kind: MethodKind.Unary,
  I: UpdateBlogPostRequest,
  O: UpdateBlogPostResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.DeleteBlogPost
 */
export const deleteBlogPost = {
  localName: "deleteBlogPost",
  name: "DeleteBlogPost",
  kind: MethodKind.Unary,
  I: DeleteBlogPostRequest,
  O: DeleteBlogPostResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.GetBlogPostSlug
 */
export const getBlogPostSlug = {
  localName: "getBlogPostSlug",
  name: "GetBlogPostSlug",
  kind: MethodKind.Unary,
  I: GetBlogPostSlugRequest,
  O: GetBlogPostSlugResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};

/**
 * @generated from rpc fingertip.creator.blog_post.v1.BlogPostService.DuplicateBlogPost
 */
export const duplicateBlogPost = {
  localName: "duplicateBlogPost",
  name: "DuplicateBlogPost",
  kind: MethodKind.Unary,
  I: DuplicateBlogPostRequest,
  O: DuplicateBlogPostResponse,
  service: {
    typeName: "fingertip.creator.blog_post.v1.BlogPostService"
  }
};
